<template>
  <div class="img-wrap">
    <div class="img-content" v-for="(item, index) in photoList" :key="index">
      <el-image
        style="width: 100px; height: 100px; margin: 20px"
        :src="item.fileUrl"
        :preview-src-list="imgList"
      >
      </el-image>
      <span class="upload-time">{{ item.lastModified || '--' }}</span>
    </div>
      <video
      v-for="(item) in videoList"
      :key="item.id"
      style="width: 200px; height: 100px;margin-right:20px"
      :src="item"
      :controls="controls"
    >
    </video>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    value(newVal) {
      const photoVoList = (newVal || []).filter((f) => f.fileUrl.indexOf('mp4') === -1);
      const videoVoList = (newVal || []).filter((f) => f.fileUrl.indexOf('mp4') !== -1);
      this.photoList = photoVoList;
      this.imgList = this.photoList.map((item) => item.fileUrl);
      this.videoList = videoVoList.map((item) => item.fileUrl);
    },
  },
  data() {
    return {
      imgList: [],
      photoList: [],
      videoList: [],
      controls: true,
    };
  },
};
</script>

<style scoped>
.img-wrap{
    display: flex;
    align-items: center;
    flex-flow: wrap;
    margin-bottom: 20px;
}
.img-content{
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}
.upload-time{
  font-size: 12px;
  color: #909399;
}
</style>
